import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SwitchChatDropdown = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const sections = ["trials", "research", "drugs", "agent-owl"];
  const match = sections.find(s => location.pathname.startsWith(`/${s}`));
  const current = match || "chat";

  const handleChange = (e) => {
    if (e.target.value === "research") {
      navigate("/chat");
    } else if (e.target.value === "trials") {
      navigate("/trials");
    } else if (e.target.value === "agent-owl") {
      navigate("/agent-owl");
    } else {
      navigate("/drugs");
    }
  };

  return (
    <select
      value={current}
      onChange={handleChange}
      style={{
        position: 'absolute',
        top: 16,
        right: 24,
        zIndex: 1000,
        background: '#fff',
        color: '#222',
        border: '1px solid #d1d5db',
        borderRadius: 8,
        padding: '8px 16px',
        fontSize: 16,
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        outline: 'none',
        cursor: 'pointer',
        transition: 'border 0.2s',
      }}
    >
      <option value="research">Research</option>
      <option value="trials">Clinical Trials</option>
      <option value="drugs">Drugs Agent</option>
      <option value="agent-owl">Agent Owl</option>

    </select>
  );
};

export default SwitchChatDropdown;
